import styled from 'styled-components';

const OrientationPopupStyle = styled.div`
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	width: 100vw;
	height: 100vh;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: var(--sp6x) 0;
	background-color: var(--black1000);
	z-index: 100000;

	.flex-center-block {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		gap: var(--sp2x);
		text-align: center;
	}

	svg {
		will-change: transform;
		animation: rotateAnim 1s linear infinite;
	}

	@keyframes rotateAnim {
		0% {
			transform: rotate(0deg);
		}

		50% {
			transform: rotate(-90deg);
		}

		100% {
			transform: rotate(0deg);
		}
	}
`;

export default OrientationPopupStyle;
